import { render, staticRenderFns } from "./ReferenceSearchModal.vue?vue&type=template&id=37cb9f3f&scoped=true"
import script from "./ReferenceSearchModal.vue?vue&type=script&lang=js"
export * from "./ReferenceSearchModal.vue?vue&type=script&lang=js"
import style0 from "./ReferenceSearchModal.vue?vue&type=style&index=0&id=37cb9f3f&prod&scoped=true&lang=css"
import style1 from "./ReferenceSearchModal.vue?vue&type=style&index=1&id=37cb9f3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb9f3f",
  null
  
)

export default component.exports